window.addEventListener("click", (event) => {
    const target = event.target;
    const form = target.closest("[data-form]");

    // Nav Primary Trigger
    if (target.classList.contains("js-nav-primary-trigger")) {
        target.blur();
        target.classList.toggle("is-active");

        document.querySelector(".app-nav-primary").classList.toggle("is-open");
    }

    // Fake Dropdown Trigger
    if (target.classList.contains("js-fake-dropdown-trigger")) {
        target.blur();

        const thisFakeDropDown = target.closest(".fake-dropdown");
        thisFakeDropDown.classList.toggle("is-open");

        closeAllOpenFakeDropdowns(thisFakeDropDown);
    }

    if (!target.closest(".fake-dropdown")) {
        closeAllOpenFakeDropdowns();
    }

    // History Back
    if (target.classList.contains("js-history-back")) {
        if (document.referrer.includes(window.location.host)) {
            history.back();
        } else {
            window.location.href = target.dataset.fallback;
        }
    }

    if (form) {

        // Set Filter
        if (target.classList.contains("js-job-search-set-filter")) {
            const checkbox = document.getElementById(target.dataset.id);
            const checkboxes = [...document.querySelectorAll(`[name="${checkbox.name}"]`)].filter(item => item != checkbox);

            checkbox.checked = true;

            if (checkboxes.length) {
                [...checkboxes].forEach(item => {
                    item.checked = false;
                });
            }

            fetchFilteredData(form);
        }

        // Remove Filter
        if (target.classList.contains("js-job-search-remove-filter")) {
            const checkbox = document.getElementById(target.dataset.id);
            checkbox.checked = false;

            fetchFilteredData(form);
        }

        // Reset Filters
        if (target.classList.contains("js-job-search-reset-filters")) {
            const inputsText = form.querySelectorAll('input[type="text"]');
            if (inputsText.length) {
                [...inputsText].forEach(item => {
                    item.value = '';
                });
            }

            const checkedCheckboxes = form.querySelectorAll('input[type="checkbox"]:checked');
            if (checkedCheckboxes.length) {
                [...checkedCheckboxes].forEach(item => {
                    item.checked = false;
                });
            }

            if (inputsText.length || checkedCheckboxes.length) {
                fetchFilteredData(form);
            }
        }

        // Clear Filters Group
        if (target.classList.contains("js-job-search-clear-filters-group")) {
            const checkboxes = form.querySelectorAll(`[name="${target.dataset.name}"]:checked`);

            if (checkboxes.length) {
                [...checkboxes].forEach(item => {
                    item.checked = false;
                });

                fetchFilteredData(form, target);
            }
        }
    }
});

function closeAllOpenFakeDropdowns(current = null) {
    let openFakeDropdowns = document.querySelectorAll(".fake-dropdown.is-open");

    if (current) {
        openFakeDropdowns = [...openFakeDropdowns].filter(item => item != current);
    }

    if (openFakeDropdowns) {
        [...openFakeDropdowns].forEach(item => {
            item.classList.remove("is-open");
        });
    }
}

ajaxFilters();

function ajaxFilters() {
    window.addEventListener("popstate", () => {
        window.location = location.href;
    });

    window.addEventListener("submit", (event) => {
        event.preventDefault();

        const target = event.target;
        const form = target.closest("[data-form]");

        if (form) {
            fetchFilteredData(form, target);
        }
    });

    window.addEventListener("click", (event) => {
        if (event.target.dataset.moreContainer) {
            event.preventDefault();
            fetchNextData(event.target);
        }
    });
}

async function fetchFilteredData(form, target = null) {
    const blockName = form.dataset.form;
    const targetSelector = `[data-content="${blockName}"]`;
    document.querySelector(targetSelector).classList.add("is-loading");

    const data = new FormData(form);
    const query = new URLSearchParams();
    query.append("ajax", blockName);
    for (const [key, value] of data.entries()) {
        query.append(key, value);
    }

    const response = await fetch(`${form.action}?${query.toString()}`);
    const body = await response.text();
    const div = document.createElement("div");
    div.innerHTML = body;

    // if (target) {
    //     const fakeDropdown = div.querySelector(`#${target.id}`).closest(".fake-dropdown");
    //     if (fakeDropdown) {
    //         fakeDropdown.classList.add("is-open");
    //     }
    // }

    document.querySelector(targetSelector).innerHTML = div.querySelector(targetSelector).innerHTML;

    document.querySelector(targetSelector).classList.remove("is-loading");
    window.history.pushState({}, null, response.url.replace(`ajax=${blockName}`,""));
}

async function fetchNextData(btn) {
    const container = btn.dataset.container;
    const targetSelector = `[data-content="${container}"]`;
    const moreContainer = btn.dataset.moreContainer;
    document.querySelector(targetSelector).classList.add('is-loading');
    btn.style.pointerEvents = 'none';
    btn.style.cursor = 'default';

    const response = await fetch(btn.href);
    const body = await response.text();
    const div = document.createElement('div');
    div.innerHTML = body;
    document.querySelector(moreContainer).innerHTML += div.querySelector(moreContainer).innerHTML;

    const newBtn = div.querySelector(`#${btn.id}`);

    if (newBtn) {
        btn.replaceWith(newBtn);
    } else {
        btn.remove();
    }

    document.querySelector(targetSelector).classList.remove('is-loading');
}

window.addEventListener("load", () => {
    const listsAccordion = document.querySelectorAll(".js-list-accordion");

    if (listsAccordion) {
        [...listsAccordion].forEach(list => {
            const wrapper = list.closest(".js-list-accordion--wrapper");
            const trigger = wrapper.querySelector(".js-list-accordion--trigger");

            let listH = setH(list);

            window.addEventListener("resize", () => {
                listH = setH(list);
            });

            if (listH) {
                trigger.classList.remove("is-hidden");

                trigger.addEventListener("click", () => {
                    trigger.classList.toggle("is-open");

                    if (trigger.classList.contains("is-open")) {
                        list.style.height = `${listH.hFull}px`;
                    } else {
                        list.style.height = `${listH.h}px`;
                    }
                });
            }
        });

        function setH(list) {
            const items = list.querySelectorAll("li");

            let h = 0;
            let hFull = 0;

            if (items && items.length > 10) {
                [...items].forEach((item, index) => {
                    hFull += item.offsetHeight;

                    if (index > 9) {
                        h += item.offsetHeight;
                        item.classList.add("hide");
                    }
                });

                h = hFull - h;
                list.style.height = `${h}px`;

                return { h, hFull };
            }

            return null;
        }
    }
});
